import AppRoutes from "../router/app-routes";
import "./App.css";
import { initializeAnalytics } from "../services/analytics";

initializeAnalytics();

function App() {
  return <AppRoutes />;
}

export default App;